import { atom } from 'jotai';
import type { StageSettingsT } from '../../labelling/providers/stage-provider/types';
import { EDITOR_MODE_TYPE } from '../../labelling/types';
export const DEFAULT_STAGE_SETTINGS: StageSettingsT = {
  x: 0,
  y: 0,
  // scale 0 - 1 (number) - reference https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/scale
  scale: 1,
  // Rotation in degree - 0 to 360 deg - reference https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/rotate
  rotation: 0
};
export const stageSettingsAtom = atom<StageSettingsT>(DEFAULT_STAGE_SETTINGS);
export const stageSettingsRotationAtom = atom<StageSettingsT['rotation']>(get => get(stageSettingsAtom).rotation);
export const stageSettingsScaleAtom = atom<StageSettingsT['scale']>(get => get(stageSettingsAtom).scale);
export const stageSettingsXYAtom = atom<{
  x: StageSettingsT['x'];
  y: StageSettingsT['y'];
}>(get => ({
  x: get(stageSettingsAtom).x,
  y: get(stageSettingsAtom).y
}));
const fitToScreenHandlerAtom = atom<{
  handler: () => void;
}>({
  handler: () => {}
});
export const fitToScreenAtom = atom(get => get(fitToScreenHandlerAtom).handler, (_get, set, newHandler: () => void) => {
  set(fitToScreenHandlerAtom, {
    handler: newHandler
  });
});
export const editorModeAtom = atom<(typeof EDITOR_MODE_TYPE)[keyof typeof EDITOR_MODE_TYPE]>(EDITOR_MODE_TYPE.LABELING);